import { useEffect, useState } from "react";
import { Card, CardBody, CardTitle, CardSubtitle, Table } from "reactstrap";

import user3 from "../../assets/images/users/user3.jpg";
import user4 from "../../assets/images/users/user4.jpg";
import user5 from "../../assets/images/users/user5.jpg";

import maleAvatar from "../../assets/images/users/user4.jpg";   
import femaleAvatar from "../../assets/images/users/user1.jpg"; 

import axiosInstance from "../../request";
import { URL } from "../../api";

const defaultAvatars = [user3, user4, user5];

const companyCode = localStorage.getItem("companyCode");
const branchCode = localStorage.getItem("branch_code");

const CustomerTable = () => {
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    const fetchCustomers = async () => {
            try {
            const params = {};

      if (companyCode) {
        params.company_code = companyCode;
      }

      if (companyCode && branchCode) {
        params.branch_code = branchCode;
      }

      const res = await axiosInstance.get(URL.GET_ALL, { params });
        let data = Array.isArray(res.data) ? res.data : [];

        // Sort descending by created_date then customer_id
        data.sort((a, b) => {
          const dateA = new Date(a.created_date);
          const dateB = new Date(b.created_date);
          if (dateA.getTime() === dateB.getTime()) {
            return b.customer_id - a.customer_id;
          }
          return dateB - dateA;
        });

        setCustomers(data.slice(0, 5)); // take top 5 latest
      } catch (error) {
        console.error("Error fetching customers:", error);
      }
    };

    fetchCustomers();
  }, []);

  // Get gender text from string value
  const getGenderText = (gender) => {
    if (!gender) return "-";
    if (typeof gender === "string") {
      if (gender.toLowerCase() === "male") return "Male";
      if (gender.toLowerCase() === "female") return "Female";
    }
    return "-";
  };

  return (
    <div>
      <Card>
        <CardBody>
          <CardTitle tag="h5">Customer List</CardTitle>
          <CardSubtitle className="mb-2 text-muted" tag="h6">
            Overview of the Customers
          </CardSubtitle>

          <Table className="no-wrap mt-3 align-middle" responsive borderless>
            <thead>
              <tr>
                <th>Customer Name</th>
                <th>Phone</th>
                <th>Gender</th>
                <th>Status</th>
                <th>Date</th>
                <th>PAN Number</th>
                <th>Pin Code</th>
              </tr>
            </thead>
            <tbody>
              {customers.length > 0 ? (
                customers.map((data, index) => {
                  // Select avatar based on gender string
                  let avatarSrc = maleAvatar; // default male avatar
                  if (data.gender && typeof data.gender === "string") {
                    if (data.gender.toLowerCase() === "female") {
                      avatarSrc = femaleAvatar;
                    } else if (data.gender.toLowerCase() !== "male") {
                      avatarSrc = defaultAvatars[index % defaultAvatars.length];
                    }
                  } else {
                    avatarSrc = defaultAvatars[index % defaultAvatars.length];
                  }

                  return (
                    <tr key={index} className="border-top">
                      <td>
                        <div className="d-flex align-items-center p-2">
                          <img
                            src={avatarSrc}
                            className="rounded-circle"
                            alt="avatar"
                            width="45"
                            height="45"
                          />
                          <div className="ms-3">
                            <h6 className="mb-0">{data.full_name || "-"}</h6>
                            <span className="text-muted">{data.email || "-"}</span>
                          </div>
                        </div>
                      </td>
                      <td>{data.phone_number || "-"}</td>
                      <td>{getGenderText(data.gender)}</td>
                      <td>{data.status || "-"}</td>
                      <td>
                        {data.created_date
                          ? new Date(data.created_date).toLocaleDateString()
                          : "-"}
                      </td>
                      <td>{data.pan_number || "-"}</td>
                      <td>{data.pin_code || "-"}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="7" className="text-center text-muted">
                    No customer data available
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </div>
  );
};

export default CustomerTable;
